'use strict';

/* globals define, $,config, app, utils, ajaxify, window, socket, document */

define('chatFileUpload', ['components', 'forum/chats/messages'], function (components, messages) {
	var videoRegex = /^video:([0-9]+)$/;

	var ChatFileUpload = {};

	ChatFileUpload.init = function () {
		ChatFileUpload.addUploadBtnAction();
		ChatFileUpload.onChatFileUpload();
		ChatFileUpload.onChatMessageReceived();
	};

	ChatFileUpload.uploadChatContentFiles = function (params, onSuccess) {
		var filesForm = components.get('chat/upload-form');

		filesForm.attr('action', config.relative_path + params.route);

		filesForm.off('submit').submit(function () {
			components.get('chat/upload-progress').css('display', 'block');

			$(this).ajaxSubmit({
				headers: {
					'x-csrf-token': config.csrf_token,
				},
				resetForm: true,
				clearForm: true,
				formData: params.formData,
				data: { },

				error: function (xhr) {
					app.alertError(xhr.responseJSON.error);
				},

				uploadProgress: function (event, position, total, percent) {
					components.get('chat/upload-progress').css('width', percent + '%');
				},

				success: function (uploads) {
					onSuccess(uploads, params);
				},

				complete: function () {
					$('body').data('isUploading', false);
					components.get('chat/upload-progress').css('display', 'none');
				},
			});

			return false;
		});

		filesForm.submit();
	};

	ChatFileUpload.getFileNameFromUrl = function (fileUrl) {
		return fileUrl.replace(/^.*[\\/]/, '');
	};

	ChatFileUpload.onChatFileUploadSuccess = function (uploads, roomId) {
		var upload = uploads.response.images[0] || {};
		var fileUrl = upload.url;

		var isImage = /[/.](gif|jpg|jpeg|tiff|png)$/g.test(fileUrl.toLowerCase());
		var name = upload.name ? upload.name : ChatFileUpload.getFileNameFromUrl(fileUrl);

		var msg = (isImage ? '!' : '') + '[' + name + '](' + fileUrl + ')';

		ChatFileUpload.sendUploadedFileMessage(roomId, msg, fileUrl);
	};

	ChatFileUpload.sendUploadedFileMessage = function (roomId, msg, fileUrl) {
		if (!msg.trim().length) {
			return;
		}

		$(window).trigger('action:chat.sent', {
			roomId: roomId,
			message: msg,
		});

		socket.emit('modules.chats.send', {
			roomId: roomId,
			message: msg,
		}, function (err) {
			if (err) {
				return app.alert({
					alert_id: 'chat_spam_error',
					title: '[[global:alert.error]]',
					message: err.message,
					type: 'danger',
					timeout: 10000,
				});
			}

			ChatFileUpload.saveUploadedFilePermissions(fileUrl, roomId);
			ChatFileUpload.wrapImagesInLinks();
			ChatFileUpload.showVideo();
		});
	};

	ChatFileUpload.saveUploadedFilePermissions = function (fileName, roomId) {
		if (videoRegex.test(fileName)) {
			return saveUploadedVideoPermissions(fileName, roomId);
		}

		socket.emit('plugins.filePermissionSockets.saveFileFromChatPrivileges', { fileName, roomId }, function (err) {
			if (err) {
				return app.alertError(err.message);
			}
		});
	};

	ChatFileUpload.onChatMessageReceived = function () {
		socket.on('event:chats.receive', function () {
			setTimeout(function () {
				ChatFileUpload.wrapImagesInLinks();
				ChatFileUpload.showVideo();
				scrollToLastMessage();
			}, 800);
		});
	};

	ChatFileUpload.addUploadBtnAction = function () {
		components.get('chat/composer').find('[data-action=upload-file]').on('click', function () {
			$('body').data('isUploading', true);

			components.get('chat/upload-form').find('input').click();
		});
	};

	ChatFileUpload.onChatFileUpload = function () {
		components.get('chat/upload-form').find('input').on('change', function (e) {
			var files = (e.target || {}).files || ($(this).val() ? [{ name: $(this).val(), type: utils.fileMimeType($(this).val()) }] : null);

			if (files) {
				var roomId = ajaxify.data.roomId || $(this).closest('.chat-modal').attr('data-roomid');

				ChatFileUpload.uploadChatContentFiles({
					files: files,
					route: '/api/post/upload',
					filename: $(this).val().replace(/^.*[\\/]/, ''),
				}, function (uploads) {
					ChatFileUpload.onChatFileUploadSuccess(uploads, roomId);
				});
			}
		});
	};

	ChatFileUpload.wrapImagesInLinks = function () {
		components.get('chat/messages').find('[component="chat/message/body"] img:not(.emoji)').each(function () {
			var $this = $(this);
			var src = $this.attr('src') || '';
			var alt = $this.attr('alt') || '';
			var suffixRegex = /-resized(\.[\w]+)?$/;

			if (src === 'about:blank') {
				return;
			}

			if (utils.isRelativeUrl(src) && suffixRegex.test(src)) {
				src = src.replace(suffixRegex, '$1');
			}
			var srcExt = src.split('.').slice(1).pop();
			var altFilename = alt.split('/').pop();
			var altExt = altFilename.split('.').slice(1).pop();

			if (!$this.parent().is('a')) {
				$this.wrap('<a href="' + src + '" ' +
					(!srcExt && altExt ? ' download="' + altFilename + '" ' : '') +
					' target="_blank" >');
			}
		});

		$(document).trigger('addImagePreviewOnMobiles');
	};

	ChatFileUpload.showVideo = function () {
		setTimeout(function () {
			$('.custom-video').customVideo('chats', function () {
				scrollToLastMessage();
			});
		}, 500);
	};

	function saveUploadedVideoPermissions(fileName, roomId) {
		var videoId = videoRegex.exec(fileName)[1];

		if (!videoId) {
			return;
		}

		socket.emit('plugins.videoSockets.getVideo', videoId, function (err, video) {
			if (err) {
				return app.alertError(err.message);
			}

			ChatFileUpload.saveUploadedFilePermissions(video.url, roomId);
			ChatFileUpload.saveUploadedFilePermissions(video.thumbnailUrl, roomId);
		});
	}

	function scrollToLastMessage() {
		messages.scrollToBottom($('.expanded-chat ul.chat-content'));
	}

	return ChatFileUpload;
});
